import ChangeLifecycleButtons from "eSign/components/ChangeLifecycleButtons";
import React from "react";
import { Message } from "semantic-ui-react";

interface Props {
  documentId: number
}

const SendOutDocument = (props: Props) => {

  return <div className="flex-column gap">
    <Message color="red" className="margin-bottom">
      Once you send out an invoice, you cannot make changes. Are you sure that the content of the document is correct?
    </Message>

    <div className="grow1"></div>

    <ChangeLifecycleButtons
      documentType="invoice"
      documentId={props.documentId}
      right="pending"
    />
  </div>;
};

export default SendOutDocument;